
/**
 * @name Block.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\Block.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import Swal from 'sweetalert2';
import TableBuilder from '../../table_builder.js';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, getCourtesyType = null, getCourtesyIsUsed = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        getCourtesyType = utils.getCourtesyType;
        getCourtesyIsUsed = utils.getCourtesyIsUsed;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/bloqueios')
            return;

        new FinancialBlocks(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class FinancialBlocks
{
    constructor(onloadList=false, deps = {})
    {
        
        this.deps = deps;
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-financial-blocks-list',
            tableBody: '.js-financial-blocks-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-financial-blocks-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudBlocksHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchBlocksList();
            },
            OnClickLastPage: function() {
                self.fetchBlocksList();
            },
        });

        getSecUsers(users => {
            console.log('users', users);
            let html = '<option value="" selected disabled>-- Selecione --</option>';
            users.forEach(user => {
                html += `<option value="${user.LOGIN}">${user.LOGIN}</option>`;
            });
            $('.js-financial-blocks-registrations-requester').html(html);
            $('select[name="courtesy_edit_requester"]').html(html);
        });
        
        this.fetchBlocksList();
        this.bindDomTableAndFilterEvents();
        this.bindDomEvents();
    }

    fetchBlocksList() {
        let self = this;
        $(".js-financial-blocks-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/financial/blocks',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-financial-blocks-per-page option:selected').val()),
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.patientState !== -1 ? { patientState: self.patientState } : {},
                ...self.blockType !== -1 ? { blockType: self.blockType } : {},
            },
            successCallback: function(res) {
                $(".js-financial-blocks-registrations-table").unblock();
                if (!res.error) {
                    self.financialBlocksList = res.data;
                    self.financialBlocksTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.financialBlocksList, false, self.financialBlocksTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (courtesy) => {
        let row = `<tr>
            <td>${courtesy.BLOQUEADO == 'S' ? 'Sim' : 'Não'}</td>
            <td>${courtesy.ID}</td>
            <td>${getBranchNameFromId(courtesy.FILIAL_ID)}</td>
            <td>${courtesy.CLIENTE_NOME}</td>
            <td>${courtesy.CONTRATO_ID}</td>
            <td>${courtesy.USUARIO_LOGIN}</td>
            <td>${courtesy.USUARIO_DATA_FORMATTED}</td>
            <td>${courtesy.OBS}</td>
        </tr>`;

        return row;
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchBlocksList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchBlocksList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchBlocksList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-financial-blocks-registrations-branches-selector').change(function() {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchBlocksList();
            } else {
                self.selectedBranch = -1;
            }
        });

        $('.js-financial-blocks-registrations-is-block').change(function() {
            self.patientState = $(this).val();
        });

        $('.js-financial-blocks-registrations-block-type').change(function() {
            self.blockType = $(this).val();
        });

        // Detecta usuário buscando pelo nome do paciente
        $('#js-financial-blocks-registrations-search-input').on('input', function() {
            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function() {
                self.searchQuery = $('#js-financial-blocks-registrations-search-input').val().trim();
                if (self.searchQuery.length > 3) {
                    self.fetchBlocksList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchBlocksList();
                }
            }, 500);
        })


        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-financial-blocks-per-page', function() {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchBlocksList();
        });
    }

    bindDomEvents() {
        let self = this;

        $('#block_create_contract').prop('disabled', true);
        $('#block_create_is_financial_block').prop('disabled', true);
        $('#block_create_type').prop('disabled', true);
        $('#block_create_description').prop('disabled', true);

        $('#block_create_customer').select2({
            placeholder: "Busque por nome ou código do contrato",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            dropdownParent: $("#modal-financial-block-create"),
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function(params) {
                    var query = {
                        search: params.term,
                        branchId: self.insertSelectedBranch || -1,
                        page: params.page || 1,
                        allContracts: true
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function(k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });
        $('#block_create_customer').prop('disabled', true);

        $('#block_create_customer').on('select2:select', function(e) {
            console.log('e.params.data', e.params.data);
            $("#block_create_customer_id").val(e.params.data.info.ID);

            $('#block_create_branch').prop('disabled', true);
            $('#block_create_contract').prop('disabled', false);

            $('#block_create_contract').html('');
            let contratos = Object.keys(e.params.data.info.CONTRATOS);
            let html = '<option value="" selected disabled>-- Selecione --</option>';
            contratos.forEach(contract => {
                if (contract != 0) {
                    html += `<option value="${contract}">${contract}</option>`;
                }
            });
            $('#block_create_contract').html(html);
        });

        $("#block_create_branch").change(function() {
            self.insertSelectedBranch = $(this).val();
            if (self.insertSelectedBranch == '') {
                $('#block_create_customer').prop('disabled', true);
            } else {
                $('#block_create_customer').prop('disabled', false);
            }
        });

        $("#block_create_contract").change(function() {
            self.insertSelectedContract = $(this).val();
            if (self.insertSelectedContract == '') {
                $('#block_create_is_financial_block').prop('disabled', true);
                $('#block_create_type').prop('disabled', true);
                $('#block_create_description').prop('disabled', true);
            } else {
                $('#block_create_is_financial_block').prop('disabled', false);
                $('#block_create_type').prop('disabled', false);
                $('#block_create_description').prop('disabled', false);
            }
        });

        $(document).on('click', '.js-block-create-clear', function() {
            $('#block_create_customer').val(null).trigger('change');
            $('#block_create_is_financial_block').val(null).trigger('change');
            $('#block_create_contract').val(null).trigger('change');
            $('#block_create_type').val(null).trigger('change');
            $('#block_create_description').val('');

            $('#block_create_contract').prop('disabled', true);
            $('#block_create_is_financial_block').prop('disabled', true);
            $('#block_create_type').prop('disabled', true);
            $('#block_create_description').prop('disabled', true);
            $('#block_create_branch').prop('disabled', false);
        });

        $(document).on('submit', '.js-financial-block-create-form', this.onSubmitCreate.bind(this));
    }

    onSubmitCreate(e) {
        e.preventDefault();
        let self = this;

        let data = {
            branchId: $('#block_create_branch').val(),
            customerId: $('#block_create_customer_id').val(),
            contractId: $('#block_create_contract').val(),
            isFinancialBlock: $('#block_create_is_financial_block').val(),
            blockType: $('#block_create_type').val(),
            description: $('#block_create_description').val(),
        }

        $('.js-financial-block-create-form').find('button[type="submit"]').prop('disabled', true);
        $(".modal-financial-block-create-dialog").unblock();

        Swal.fire({
            title: 'Confirmação',
            text: `Deseja realmente criar um bloqueio financeiro para o contrato ${data.contractId}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                apiCall({
                    method: 'POST',
                    endpoint: 'api/v1/financial/blocks/create',
                    data: data,
                    successCallback: function(res) {
                        $('.js-financial-block-create-form').find('button[type="submit"]').prop('disabled', false);
                        $(".modal-financial-block-create-dialog").unblock();
                        if (!res.error) {
                            window.toast({
                                text: 'Bloqueio criado com sucesso'
                            });
                            $('#modal-financial-block-create').modal('hide');
        
                            $('#block_create_branch').val(null).trigger('change');
                            $('#block_create_customer').val(null).trigger('change');
                            $('#block_create_is_financial_block').val(null).trigger('change');
                            $('#block_create_contract').val(null).trigger('change');
                            $('#block_create_type').val(null).trigger('change');
                            $('#block_create_description').val(null).trigger('change');
        
                            $('#block_create_branch').prop('disabled', false);
                            $('#block_create_customer').prop('disabled', true);
                            $('#block_create_contract').prop('disabled', true);
                            $('#block_create_is_financial_block').prop('disabled', true);
                            $('#block_create_type').prop('disabled', true);
                            $('#block_create_description').prop('disabled', true);
        
                            self.fetchBlocksList();
                        } else {
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                        }
                    },
                    errorCallback: function(err) {
                        $(".modal-financial-block-create-dialog").unblock();
                        $('.js-financial-block-create-form').find('button[type="submit"]').prop('disabled', false);
                    }
                });
            } else {
                $(".modal-financial-block-create-dialog").unblock();
                $('.js-financial-block-create-form').find('button[type="submit"]').prop('disabled', false);
            }
        });
    }
}